import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form, DatePicker } from 'antd';
import { useForm } from "antd/lib/form/Form";
import Button from "components/button";
import FormItem from "components/fields/FormItem";
import { Modal } from "antd";
import AddressFilter from "components/search/AddressFilter";
import { DATE_FORMAT } from '../../variables/constants';
import { FormatDateValue } from "../../utils/index";

const { RangePicker } = DatePicker;

function ModalSearchFilter({ title, isModalVisible, closeModal, resetHandler, filterHandler, filters, 
	getRegionList, regions, withDateRange=true, withAddress=true,
	...props }) {

	const { children } = props;
  	const [form] = useForm();
	
	useEffect(() => {
		if (filters) {
			const { date_from, date_to, ...rest } = filters;
			form.setFieldsValue({
			...rest,
			date_range: date_from && date_to
				? [FormatDateValue(date_from), FormatDateValue(date_to)]
				: undefined,
			});
		}
	}, [filters, form]);
	
  	const onSubmit = (formData) => {
		formData.date_from = formData.date_range?.[0]?.format(DATE_FORMAT) || null;
    	formData.date_to = formData.date_range?.[1]?.format(DATE_FORMAT) || null;	
		filterHandler && filterHandler(formData);
	}

	// useEffect(() => {
	// 	if (!isModalVisible) {
	// 		form.resetFields();
	// 	}
	// }, [isModalVisible, form]);
	
  return (
	<Modal
        open={isModalVisible}
        onCancel={closeModal}
        footer={null}
        title={title}
      >
		<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
			layout="vertical"
			onFinish={onSubmit}
		>
			{withDateRange && 
			<div className="border-y py-2">
				<h2 className="font-black">By Date</h2>
				<FormItem 
					name="date_range"
					label="Date Range"
				>
					<RangePicker className="font-normal"
						format={DATE_FORMAT}
						style={{
							width: 250,
						}}
					/>             
				</FormItem>
			</div>
			}
			{withAddress && 
			<>
				<div className="border-y py-2">
					<h2 className="font-black">By Location</h2>
					<AddressFilter className="form-column-2" form={form}/>
				</div>

				<div className="dark:bg-intsamis-900 text-right mt-4">
					<Button type="button" className="mx-3 min-w-[100px] text-center " onClick={resetHandler}>
						Reset
					</Button>
					<Button type="submit" className="mx-3 min-w-[100px] text-center ">
						Apply
					</Button>
				</div>
			</>
			}
		</Form>
	</Modal>
  );
}

const mapStateToProps = (state) => ({
	
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSearchFilter);
